function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyfin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.966 0.402344C30.7333 0.402344 32.166 1.85742 32.166 3.65234V23.1523C32.166 24.9473 30.7333 26.4023 28.966 26.4023C27.1987 26.4023 25.766 24.9473 25.766 23.1523V10.1523C25.766 8.35742 24.3333 6.90234 22.566 6.90234C20.7987 6.90234 19.366 8.35742 19.366 10.1523V23.1523C19.366 24.9473 17.9333 26.4023 16.166 26.4023C14.3987 26.4023 12.966 24.9473 12.966 23.1523V10.1523C12.966 8.35742 11.5333 6.90234 9.76602 6.90234H3.36602C1.5987 6.90234 0.166016 5.44727 0.166016 3.65234C0.166016 1.85742 1.5987 0.402344 3.36602 0.402344H28.966Z",
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.166016 15.0273C0.166016 13.2324 1.5987 11.7773 3.36602 11.7773C5.13333 11.7773 6.56602 13.2324 6.56602 15.0273V23.1523C6.56602 24.9473 5.13333 26.4023 3.36602 26.4023C1.5987 26.4023 0.166016 24.9473 0.166016 23.1523V15.0273Z",
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyfin);
export default __webpack_public_path__ + "static/media/myfin.032950de27e7c5efc4ccd598360776f6.svg";
export { ForwardRef as ReactComponent };